<template>
  <div class="row pr-4">
    <div class="col-12">
      <PageTitle title="Minhas campanhas" />
    </div>

    <div class="col-12 text-right">
      <button
        :class="
          promocaoStatus == true
            ? 'btn btn-danger mr-2'
            : 'btn btn-success mr-2'
        "
        @click="statusPromocao()"
      >
        <i :class="promocaoStatus == true ? 'fas fa-ban' : 'fas fa-check'"></i>
        {{ promocaoStatus == true ? 'Desativar promoção' : 'Ativar promoção' }}
      </button>

      <button class="btn btn-primary" @click="novaCampanha()">
        <i class="fas fa-plus"></i>
        Adicionar nova campanha
      </button>
    </div>

    <div class="col-12 mt-2" v-for="(campanha, i) in campanhas" :key="i">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle="'accordion-' + i"
              :variant="campanha.status == true ? 'success' : 'danger'"
            >
              Campanha: <b>{{ campanha.nome_campanha }}</b> - Início:
              <b>{{ formatarData(campanha.inicio_campanha) }}</b> - Fim:
              <b>{{ formatarData(campanha.fim_campanha) }}</b> - Expira:
              <b>{{ formatarData(campanha.expira_campanha) }}</b>
            </b-button>
          </b-card-header>
          <b-collapse
            :id="'accordion-' + i"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <div class="row">
                <div class="col-12 text-center">
                  <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                    DADOS DA CAMPANHA
                  </h4>
                </div>

                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary mr-1"
                    @click="addPontos(campanha)"
                  >
                    <i class="fas fa-plus"></i>
                    Adicionar pontos ao usuário
                  </button>

                  <button
                    class="btn btn-info mr-1"
                    @click="buscarPontos(campanha.id)"
                  >
                    <i class="fas fa-users"></i>
                    Pontos dos usuários
                  </button>

                  <button
                    class="btn btn-success mr-1"
                    @click="editarCampanha(campanha)"
                  >
                    <i class="fas fa-edit"></i>
                    Editar dados da campanha
                  </button>
                </div>

                <div class="col-4 mb-2">
                  <label>Nome da campanha:</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="campanha.nome_campanha"
                    readonly
                  />
                </div>

                <div class="col-8 mb-2">
                  <label>Descrição da campanha:</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="campanha.descricao"
                    readonly
                  />
                </div>

                <div class="col-3">
                  <label>Início da campanha:</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="formatarData(campanha.inicio_campanha)"
                    readonly
                  />
                </div>

                <div class="col-3">
                  <label>Fim da campanha:</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="formatarData(campanha.fim_campanha)"
                    readonly
                  />
                </div>

                <div class="col-3">
                  <label>Expiração da campanha:</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="formatarData(campanha.expira_campanha)"
                    readonly
                  />
                </div>

                <div class="col-3">
                  <label>Status:</label>
                  <span
                    class="cursor-pointer float-right"
                    v-b-tooltip.hover
                    :title="campanha.status == true ? 'Inativar' : 'Ativar'"
                    @click="alterarStatusCampanha(campanha.id)"
                  >
                    <i class="fas fa-sync"></i>
                  </span>
                  <button
                    :class="
                      campanha.status == true
                        ? 'statusAtivoBtn'
                        : 'statusInativoBtn'
                    "
                  >
                    {{ campanha.status == true ? 'Ativo' : 'Inativo' }}
                  </button>
                </div>

                <div class="col-12 mt-2">
                  <hr />
                </div>

                <div class="col-12 text-center">
                  <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                    REGRA(S) DA CAMPANHA
                  </h4>
                </div>

                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary"
                    @click="novaRegra(campanha.id)"
                  >
                    <i class="fas fa-plus"></i>
                    Adicionar nova regra
                  </button>
                </div>

                <div class="col-12 mt-2">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Nome da regra</th>
                        <th>Descrição</th>
                        <th>Regra</th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Criado</th>
                        <th class="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in campanha.campanha_regras"
                        :key="i"
                        v-show="campanha.campanha_regras.length > 0"
                      >
                        <td class="align-middle">{{ item.nome_regra }}</td>
                        <td class="align-middle">
                          <span v-b-tooltip.hover :title="item.descricao">{{
                            contarCaracteres(item.descricao, 50)
                          }}</span>
                        </td>
                        <td class="align-middle">
                          A cada {{ formatarValor(item.preco) }} você ganha
                          {{ item.pontos }} ponto(s)
                        </td>
                        <td class="text-center align-middle">
                          <span
                            :class="
                              item.status == true
                                ? 'statusAtivo'
                                : 'statusInativo'
                            "
                          >
                            {{ item.status == true ? 'Ativo' : 'Inativo' }}
                          </span>
                          <span
                            class="cursor-pointer ml-3"
                            v-b-tooltip.hover
                            :title="item.status == true ? 'Inativar' : 'Ativar'"
                            @click="alterarStatus(item.id)"
                          >
                            <i class="fas fa-sync"></i>
                          </span>
                        </td>
                        <td class="text-center align-middle">
                          {{ formatarData(item.created_at, true) }}
                        </td>
                        <td class="text-center align-middle">
                          <button
                            class="btn btn-success"
                            v-b-tooltip.hover
                            title="Vincular marca"
                            @click="
                              vincularMarca(
                                item.id,
                                campanha.id,
                                item.nome_regra,
                                i
                              )
                            "
                          >
                            <i class="fas fa-plus"></i>
                          </button>

                          <button
                            class="btn btn-primary mr-2 ml-2"
                            v-b-tooltip.hover
                            title="Editar"
                            @click="editarRegra(item)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>

                          <!-- <button
                            :class="item.marcas == true ? 'btn btn-danger disabledColor' : 'btn btn-danger'"
                            v-b-tooltip.hover
                            :title="item.marcas == true ? 'Você não pode excluir, por que tem marcas vinculadas a essa regra!' : 'Excluir'"
                            @click="excluirRegra(item.id, item.marcas)"
                          >
                            <i class="fas fa-trash"></i>
                          </button> -->
                        </td>
                      </tr>
                      <tr v-show="campanha.campanha_regras.length == 0">
                        <td colspan="6" class="text-center">
                          <span>Você não tem regras cadastradas!</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="col-12 mt-2">
                  <hr />
                </div>

                <div class="col-12 text-center">
                  <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                    PRÊMIO(S) DA CAMPANHA
                  </h4>
                </div>

                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary"
                    @click="novoPremio(campanha.id)"
                  >
                    <i class="fas fa-plus"></i>
                    Adicionar novo prêmio
                  </button>
                </div>

                <div class="col-12 mt-2">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th class="text-center">Foto</th>
                        <th>Nome do prêmio</th>
                        <th>Descrição</th>
                        <th class="text-center">Pontos</th>
                        <th class="text-center">Cont. Qtd. / Qtd</th>
                        <th class="text-center" style="width: 130px">Status</th>
                        <th class="text-center">Criado</th>
                        <th class="text-center" style="width: 130px">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(premio, i) in campanha.campanha_premios"
                        :key="i"
                        v-show="campanha.campanha_premios.length > 0"
                      >
                        <td class="text-center align-middle">
                          <img
                            :src="formatarUrlImagrm(premio.premio_fotos[0])"
                            :alt="premio.nome_premio"
                            width="50px"
                          />
                        </td>

                        <td class="align-middle">
                          {{ premio.nome_premio }}
                        </td>

                        <td class="align-middle">
                          <span v-b-tooltip.hover :title="premio.descricao">{{
                            contarCaracteres(premio.descricao, 50)
                          }}</span>
                        </td>

                        <td class="text-center align-middle">
                          {{ premio.pontos }} ponto(s)
                        </td>

                        <td class="text-center align-middle">
                          {{ premio.controlar_qtd == 1 ? 'Sim' : 'Não' }} /
                          {{
                            premio.controlar_qtd == 1
                              ? premio.qtd
                              : 'Qtd. ilimitada'
                          }}
                        </td>

                        <td class="text-center align-middle">
                          <span
                            :class="
                              premio.status == true
                                ? 'statusAtivo'
                                : 'statusInativo'
                            "
                          >
                            {{ premio.status == true ? 'Ativo' : 'Inativo' }}
                          </span>
                          <span
                            class="cursor-pointer ml-3"
                            v-b-tooltip.hover
                            :title="
                              premio.status == true ? 'Inativar' : 'Ativar'
                            "
                            @click="alterarStatusPremio(premio.id)"
                          >
                            <i class="fas fa-sync"></i>
                          </span>
                        </td>

                        <td class="text-center align-middle">
                          {{ formatarData(premio.created_at) }}
                        </td>
                        <td class="text-center align-middle">
                          <button
                            class="btn btn-primary mr-2 ml-2"
                            v-b-tooltip.hover
                            title="Editar"
                            @click="editarPremio(premio)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>

                          <!-- <button
                            :class=" premio.premio_solicitado.length > 0 ? 'btn btn-danger disabledColor' : 'btn btn-danger'"
                            v-b-tooltip.hover
                            :title="premio.premio_solicitado.length > 0 ? 'Você não pode excluir esse prêmio, pois já tem pedido solicitado desse prêmio!' : 'Excluir'"
                            @click="excluirPremio(premio.id, premio.premio_solicitado)"
                          >
                            <i class="fas fa-trash"></i>
                          </button> -->
                        </td>
                      </tr>
                      <tr v-show="campanha.campanha_premios.length == 0">
                        <td colspan="8" class="text-center">
                          <span>Você não tem prêmio(s) cadastrado(s)!</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

    <b-modal
      :title="this.premio.id == null ? 'Novo premio' : 'Atualizar prêmio'"
      size="lg"
      id="modal-meus-premios"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <!-- <div class="col-12" v-if="validUpdate">
            <div class="alert alert-danger" role="alert">
              Você não pode editar todos os campos desse prêmio, pois já tem pedido solicitado desse prêmio!
            </div>
          </div> -->

        <div class="col-12">
          <label>Nome do prêmio</label>
          <input
            type="text"
            v-model="premio.nome_premio"
            class="form-control"
            placeholder="Nome do prêmio"
            maxlength="150"
            :disabled="validUpdate"
          />
        </div>

        <div class="col-12">
          <label>Descrição</label>
          <textarea
            v-model="premio.descricao"
            class="form-control"
            rows="4"
            maxlength="255"
            :disabled="validUpdate"
          ></textarea>
        </div>

        <div class="col-4 mt-2">
          <label>Pontos</label>
          <input
            type="text"
            v-model="premio.pontos"
            class="form-control"
            placeholder="XX"
            v-mask="'###########'"
          />
        </div>

        <div class="col-4 text-center mt-2">
          <label
            >Controlar quantidade ({{
              premio.controlar_qtd == true ? 'Sim' : 'Não'
            }})</label
          >
          <input
            type="checkbox"
            v-model="premio.controlar_qtd"
            class="form-control"
          />
        </div>

        <div class="col-4 mt-2" v-if="premio.controlar_qtd == true">
          <label>Quantidade disponível</label>
          <input
            type="text"
            v-model="premio.qtd"
            class="form-control"
            placeholder="XX"
            v-mask="'###########'"
          />
        </div>

        <div class="col-12 mt-2">
          <label>Para qual tipo de cliente?</label>
        </div>

        <div class="col-3">
          <label>Cliente</label>
          <input type="checkbox" v-model="premio.cliente" class="ml-2" />
        </div>

        <div class="col-3">
          <label>Empresa</label>
          <input type="checkbox" v-model="premio.empresa" class="ml-2" />
        </div>

        <div class="col-3">
          <label>Profissional</label>
          <input type="checkbox" v-model="premio.profissional" class="ml-2" />
        </div>

        <div class="col-3">
          <label>Todos</label>
          <input
            type="checkbox"
            v-model="premio.all"
            class="ml-2"
            @click="selecionaPremioTodos()"
          />
        </div>

        <div
          class="col-12"
          v-if="
            premio.profissional == true &&
            premio.cliente == false &&
            premio.empresa == false
          "
        >
          <div class="row">
            <div class="col-12 mt-2">
              <label>Áreas de atuação:</label>
            </div>

            <div class="col-3" v-for="(area, i) in areas" :key="i">
              <label>{{ area.area }}</label>
              <input
                type="checkbox"
                class="ml-2"
                @click="addAreaPremio(area.id, $event.target.checked)"
                :checked="validarCheckPremio(area.id, premio.premio_areas)"
              />
            </div>
          </div>
        </div>

        <div class="col-12 mt-2">
          <label>Foto(s)</label>
          <input
            type="file"
            class="form-control"
            @change="uploadImage()"
            ref="file"
            id="file"
            accept="image/x-png"
            :disabled="validUpdate"
          />
        </div>

        <div class="col-12">
          <div class="row">
            <div
              class="col-2 text-center mt-2"
              v-for="(itemFoto, i) in premio.fotos"
              :key="i"
            >
              <span
                class="excluirFoto"
                @click="removerFoto(i, itemFoto)"
                v-if="validUpdate == false"
              >
                <i class="fas fa-times-circle"></i>
              </span>
              <img :src="formatarUrlImagrm(itemFoto)" width="50px" />
            </div>
          </div>
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success btn-block" @click="sendFormPremio()">
            {{ this.premio.id == null ? 'Criar ' : 'Atualizar ' }}prêmio
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      :title="this.fields.id == null ? 'Nova regra' : 'Atualizar regra'"
      size="md"
      id="minhas-regras"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-6">
          <label>Nome da regra</label>
          <input
            type="text"
            v-model="fields.nome_regra"
            class="form-control"
            placeholder="Nome da regra"
            maxlength="150"
          />
        </div>

        <div class="col-6">
          <label>Descrição</label>
          <input
            type="text"
            v-model="fields.descricao"
            class="form-control"
            placeholder="Descrição da regra"
            maxlength="255"
          />
        </div>

        <div class="col-6 mt-2">
          <label>A cada R$ XX,XX</label>
          <input
            type="text"
            v-model="fields.preco"
            v-money="money"
            class="form-control"
          />
        </div>

        <div class="col-6 mt-2">
          <label>Você ganhar XX pontos</label>
          <input
            type="text"
            v-model="fields.pontos"
            class="form-control"
            placeholder="XX"
            v-mask="'###########'"
          />
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success btn-block" @click="sendForm()">
            {{ this.fields.id == null ? 'Criar regra' : 'Atualizar regra' }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Pontos por usuários"
      size="lg"
      id="modal-pontos-usuarios"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <label>Áreas</label>
          <select
            v-model="selectedAreaId"
            class="form-control"
            @change="fitlerAreaId()"
          >
            <option value="">-- Selecione --</option>
            <option v-for="area in areas" :key="area.id" :value="area.id">
              {{ area.area }}
            </option>
          </select>
        </div>

        <div class="col-12 mt-2">
          <table
            class="table table-striped table-bordered"
            v-if="pontosCampanha"
          >
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF / CNPJ</th>
                <th>Área(s)</th>
                <th>Ponto(s)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in pontosCampanha" :key="i">
                <td>
                  <span v-if="item.pontos_cliente != null">
                    {{ item.pontos_cliente.first_name }}
                    {{ item.pontos_cliente.last_name }}
                  </span>

                  <span v-if="item.pontos_profissional != null">
                    {{ item.pontos_profissional.company_name }}
                  </span>

                  <span v-if="item.pontos_empresa != null">
                    {{ item.pontos_empresa.nome_fantasia }}
                  </span>
                </td>
                <td>
                  <span v-if="item.pontos_cliente != null">
                    {{ formatarDocumento(item.pontos_cliente.cpf) }}
                  </span>

                  <span v-if="item.pontos_profissional != null">
                    {{
                      item.pontos_profissional.cpf
                        ? formatarDocumento(item.pontos_profissional.cpf)
                        : formatarDocumento(item.pontos_profissional.cnpj)
                    }}
                  </span>

                  <span v-if="item.pontos_empresa != null">
                    {{ formatarDocumento(item.pontos_empresa.cnpj) }}
                  </span>
                </td>
                <td>
                  {{ getArea(item) }}
                </td>
                <td>{{ item.saldo }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      :title="this.campanha.id == null ? 'Nova campanha' : 'Atualizar campanha'"
      size="xl"
      id="minhas-campanhas"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-6">
          <label>Nome da campanha</label>
          <input
            type="text"
            v-model="campanha.nome_campanha"
            class="form-control"
            placeholder="Nome da campanha"
            maxlength="150"
          />
        </div>

        <div class="col-6">
          <label>Descrição</label>
          <input
            type="text"
            v-model="campanha.descricao"
            class="form-control"
            placeholder="Descrição da campanha"
            maxlength="255"
          />
        </div>

        <div class="col-4 mt-2">
          <label>Início da campanha</label>
          <input
            type="date"
            v-model="campanha.inicio_campanha"
            class="form-control"
          />
        </div>

        <div class="col-4 mt-2">
          <label>Fim da campanha</label>
          <input
            type="date"
            v-model="campanha.fim_campanha"
            class="form-control"
          />
        </div>

        <div class="col-4 mt-2">
          <label>Expira pontos</label>
          <input
            type="date"
            v-model="campanha.expira_campanha"
            class="form-control"
          />
        </div>

        <div class="col-12 mt-2">
          <label>Para qual tipo de cliente?</label>
        </div>

        <div class="col-3">
          <label>Cliente</label>
          <input type="checkbox" v-model="campanha.cliente" class="ml-2" />
        </div>

        <div class="col-3">
          <label>Empresa</label>
          <input type="checkbox" v-model="campanha.empresa" class="ml-2" />
        </div>

        <div class="col-3">
          <label>Profissional</label>
          <input type="checkbox" v-model="campanha.profissional" class="ml-2" />
        </div>

        <div class="col-3">
          <label>Todos</label>
          <input
            type="checkbox"
            v-model="campanha.all"
            class="ml-2"
            @click="selecionaTodos()"
          />
        </div>

        <div
          class="col-12"
          v-if="
            campanha.profissional == true &&
            campanha.cliente == false &&
            campanha.empresa == false
          "
        >
          <div class="row">
            <div class="col-12 mt-2">
              <label>Áreas de atuação:</label>
            </div>

            <div class="col-3" v-for="(area, i) in areas" :key="i">
              <label>{{ area.area }}</label>
              <input
                type="checkbox"
                class="ml-2"
                @click="addArea(area.id, $event.target.checked)"
                :checked="validarCheck(area.id, campanha.campanha_area)"
              />
            </div>
          </div>
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success btn-block" @click="sendFormCampanha()">
            {{
              this.campanha.id == null ? 'Criar campanha' : 'Atualizar campanha'
            }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      :title="'Marcas para a regra: ' + nomeRegra"
      size="xl"
      id="modal-marcas-regras"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12 text-center mb-2">
          <button class="btn btn-success btn-block" @click="atualizarMarcas()">
            ATUALIZAR MARCAS NA REGRA: {{ nomeRegra }}
          </button>
        </div>

        <div
          class="col-3 mt-2"
          v-for="(item, i) in marcas"
          :key="i"
          v-b-tooltip.hover
          :title="
            item.existe == true
              ? 'Essa marca já está na regra: ' + item.regra
              : ''
          "
        >
          <span>{{ item.marca }}</span>
          <input
            type="checkbox"
            class="formCheckbox"
            v-model="marcas[i].select"
            @click="validarMarcas(marcas[i])"
            :disabled="item.existe == true"
          />
        </div>
      </div>
    </b-modal>

    <b-modal
      :title="
        'Adicionando pontos para o usuário na campanha ' +
        dadosCampanha.nome_campanha
      "
      size="lg"
      id="modal-add-pontos"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-6 mb-2">
          <label for="cpf_cnpj">CPF/CNPJ:</label>
          <input
            type="text"
            class="form-control"
            v-model="campanhaUser"
            placeholder="###.###.###-## OU ##.###.###/####-##"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
          />
        </div>

        <div class="col-6 mb-2">
          <label for="cpf_cnpj">Quantidade de pontos:</label>
          <input
            type="number"
            class="form-control"
            v-model="campanhaPontos"
            placeholder="00"
          />
        </div>

        <div class="col-12 mb-2">
          <label for="cpf_cnpj">Mensagem:</label>
          <input
            type="text"
            class="form-control"
            v-model="campanhaMsg"
            placeholder="Ex: Você ganahou xx novos pontos!"
          />
        </div>

        <div class="col-12 text-center mb-2 mt-2">
          <button class="btn btn-success btn-block" @click="salvarPontos()">
            Adicionar ponto(s)
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'LojistaMinhasRegras',
  mixins: [makeToast],
  components: {
    PageTitle,
  },

  data() {
    return {
      campanhas: [],
      areas: [],
      marcas: [],
      marcas_add: [],
      marcas_del: [],
      nomeRegra: '',
      idCampanha: null,
      selectedAreaId: '',
      selectedCampanhaId: null,
      idRegra: null,
      posicaoArray: null,
      promocaoStatus: false,
      validUpdate: false,
      fields: {
        id: null,
        nome_regra: '',
        descricao: '',
        preco: '',
        pontos: null,
        status: true,
        campanha_id: null,
      },
      premio: {
        id: null,
        nome_premio: '',
        descricao: '',
        pontos: '',
        controlar_qtd: false,
        qtd: null,
        status: true,
        fotos: [],
        fotos_remover: [],
        campanha_id: null,
        cliente: false,
        profissional: false,
        empresa: false,
        all: false,
        tipo_profissional: [],
        premio_areas: [],
      },
      campanha: {
        id: null,
        nome_campanha: '',
        descricao: '',
        inicio_campanha: null,
        fim_campanha: null,
        expira_campanha: null,
        cliente: false,
        profissional: false,
        empresa: false,
        all: false,
        tipo_profissional: [],
        campanha_area: [],
        status: true,
        construp_user_id: null,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      pontosCampanha: [],
      dadosCampanha: [],
      campanhaUser: '',
      campanhaPontos: '',
      campanhaMsg: '',
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.get();
  },

  methods: {
    buscarPontos(campanhaId) {
      this.selectedCampanhaId = campanhaId;

      const data = {
        areaId: this.selectedAreaId,
        campanhaId: this.selectedCampanhaId,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/pontosUsuarioCampanha', data)
        .then((response) => {
          this.pontosCampanha = response.data;

          this.$bvModal.show('modal-pontos-usuarios');
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao buscar os pontos!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    fitlerAreaId() {
      this.buscarPontos(this.selectedCampanhaId);
    },
    formatarDocumento(numero) {
      numero = numero.replace(/\D/g, '');

      if (numero.length === 11) {
        return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (numero.length === 14) {
        return numero.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '$1.$2.$3/$4-$5'
        );
      }

      return numero;
    },
    addPontos(campanha) {
      this.dadosCampanha = campanha;
      this.dadosCampanha = campanha;
      this.campanhaUser = '';
      this.campanhaPontos = '';
      this.campanhaMsg = '';

      this.$bvModal.show('modal-add-pontos');
    },
    salvarPontos() {
      if (this.campanhaUser == '') {
        this.makeToast(
          'Opss',
          'Informe o documento de quem vai receber os pontos!',
          'danger'
        );
        return;
      } else if (this.campanhaPontos == '') {
        this.makeToast('Opss', 'Informe a quantidade de pontos!', 'danger');
        return;
      } else if (this.campanhaMsg == '') {
        this.makeToast(
          'Opss',
          'Informe uma mensagem para os pontos adicionados!',
          'danger'
        );
        return;
      }

      const data = {
        campanhaId: this.dadosCampanha.id,
        construpUserId: this.dadosCampanha.construp_user_id,
        campanhaUser: this.campanhaUser,
        campanhaPontos: this.campanhaPontos,
        campanhaMsg: this.campanhaMsg,
      };

      this.$store
        .dispatch('shopkeeper/addPontos', data)
        .then((response) => {
          if (response.data.error) {
            this.makeToast('Opss', response.data.message, 'danger');
          } else {
            this.makeToast(
              'Sucesso',
              'Pontos adicionados com sucesso!',
              'success'
            );

            this.$bvModal.hide('modal-add-pontos');
          }
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao adicionar os pontos!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    get() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/minhasRegras', this.dadosUsuario.id)
        .then((response) => {
          this.promocaoStatus = response.data.status;
          this.campanhas = response.data.campanhas;
          this.areas = response.data.areas;
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao buscar suas regras!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    formatarUrlImagrm(path) {
      if (path && path.foto) {
        return (
          'https://construp-imagens.s3.us-east-2.amazonaws.com/premio/' +
          path.foto
        );
      }

      return 'https://construp-imagens.s3.us-east-2.amazonaws.com/sem-image.png';
    },
    statusPromocao() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/alterarStatusPromocao', this.dadosUsuario.id)
        .then((response) => {
          if (response.data.error == false) {
            this.promocaoStatus = response.data.status;
            this.makeToast('Sucesso', response.data.message, 'success');
          } else {
            this.makeToast('Opss', response.data.message, 'danger');
          }
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao atualizar status da promoção!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    vincularMarca(id, campanhaId, nome, i) {
      const data = {
        id: id,
        campanhaId: campanhaId,
      };

      this.idCampanha = campanhaId;

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/minhasMarcas', data)
        .then((response) => {
          this.marcas = response.data;
          this.nomeRegra = nome;
          this.idRegra = id;
          this.posicaoArray = i;

          this.$bvModal.show('modal-marcas-regras');
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao buscar suas regras!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    validarCheck(id, array) {
      var check = array.filter((i) => i.area_id == id);

      if (check.length > 0) {
        this.campanha.tipo_profissional[id] = id;
      }

      return check.length > 0;
    },
    validarCheckPremio(id, array) {
      var check = array.filter((i) => i.area_id == id);

      if (check.length > 0) {
        this.premio.tipo_profissional[id] = id;
      }

      return check.length > 0;
    },
    sendFormCampanha() {
      var valid = this.validarFormCampanha();

      if (valid == true) {
        this.campanha.construp_user_id = this.dadosUsuario.id;

        if (
          this.campanha.cliente == true ||
          this.campanha.empresa == true ||
          this.campanha.profissional == false
        ) {
          this.campanha.tipo_profissional = [];
        }

        this.campanha.tipo_profissional =
          this.campanha.tipo_profissional.filter(function (valor) {
            return valor !== null;
          });

        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/sendFormCampanhas', this.campanha)
          .then((response) => {
            if (response.data.error == false) {
              this.$bvModal.hide('minhas-campanhas');
              this.makeToast('Sucesso', response.data.message, 'success');
              this.get();
            } else {
              this.makeToast('Opss', response.data.message, 'danger');
              this.$store.dispatch('endLoader');
            }
          })
          .catch(() => {
            this.makeToast(
              'Opss',
              'Houve um erro ao buscar suas campanhas!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          });
      }
    },
    sendForm() {
      var valid = this.validarForm();

      if (valid == true) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/sendFormRegras', this.fields)
          .then((response) => {
            if (response.data.error == false) {
              this.$bvModal.hide('minhas-regras');
              this.makeToast('Sucesso', response.data.message, 'success');
              this.get();
            } else {
              this.makeToast('Opss', response.data.message, 'danger');
              this.$store.dispatch('endLoader');
            }
          })
          .catch(() => {
            this.makeToast(
              'Opss',
              'Houve um erro ao buscar suas regras!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          });
      }
    },
    atualizarMarcas() {
      if (this.marcas_add.length > 0 || this.marcas_del.length > 0) {
        const data = {
          idRegra: this.idRegra,
          marcasAdd: this.marcas_add,
          marcasDell: this.marcas_del,
        };

        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/atualizarMarcasRegra', data)
          .then((response) => {
            if (response.data.error == false) {
              this.marcas_add = [];
              this.marcas_add = [];
              this.marcas = [];

              this.$bvModal.hide('modal-marcas-regras');
              this.makeToast('Sucesso', response.data.message, 'success');
            } else {
              this.makeToast('Opss', response.data.message, 'danger');
            }
            this.$store.dispatch('endLoader');
          })
          .catch(() => {
            this.makeToast(
              'Opss',
              'Houve um erro ao buscar suas regras!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          });
      }
    },
    addArea(id, isChecked) {
      if (isChecked == true) {
        this.campanha.tipo_profissional[id] = id;
      } else {
        delete this.campanha.tipo_profissional[id];
      }
    },
    addAreaPremio(id, isChecked) {
      if (isChecked == true) {
        this.premio.tipo_profissional[id] = id;
      } else {
        delete this.premio.tipo_profissional[id];
      }
    },
    alterarStatus(id) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/alterarStatusRegra', id)
        .then((response) => {
          if (response.data.error == false) {
            this.makeToast('Sucesso', 'Status atulizado!', 'success');
            this.get();
          } else {
            this.makeToast(
              'Opss',
              'Houve um erro ao atualizar o status!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao atualizar o status!',
            'danger'
          );
          this.$store.dispatch('endLoader');
        });
    },
    alterarStatusCampanha(id) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/alterarStatusCampanha', id)
        .then((response) => {
          if (response.data.error == false) {
            this.makeToast('Sucesso', 'Status atulizado!', 'success');
            this.get();
          } else {
            this.makeToast(
              'Opss',
              'Houve um erro ao atualizar o status!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Houve um erro ao atualizar o status!',
            'danger'
          );
          this.$store.dispatch('endLoader');
        });
    },
    excluirRegra(id, status) {
      if (status == true) {
        this.makeToast(
          'Opss',
          'Você não pode excluir, por que tem marcas vinculadas a essa regra!',
          'danger'
        );
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/excluirRegra', id)
        .then((response) => {
          if (response.data.error == false) {
            this.makeToast('Sucesso', 'Regra excluída!', 'success');
            this.get();
          } else {
            this.makeToast(
              'Opss',
              'Houve um erro ao excluir a regra!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao excluir a regra!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    validarMarcas(item) {
      if (item.select == false) {
        if (item.id == null) {
          this.marcas_add.push(item);
        }

        this.marcas_del = this.marcas_del.filter((i) => i.marca !== item.marca);
      }

      if (item.select == true) {
        if (item.id != null) {
          this.marcas_del.push(item);
        }

        this.marcas_add = this.marcas_add.filter((i) => i.marca !== item.marca);
      }
    },
    novaRegra(id) {
      this.limparCampos();

      this.fields.campanha_id = id;
      this.$bvModal.show('minhas-regras');
    },
    novoPremio(id) {
      this.limparCamposPremio();

      this.premio.campanha_id = id;
      this.$bvModal.show('modal-meus-premios');
    },
    novaCampanha() {
      this.limparCamposCampanha();
      this.$bvModal.show('minhas-campanhas');
    },
    editarPremio(item) {
      this.premio.id = item.id;
      this.premio.nome_premio = item.nome_premio;
      this.premio.descricao = item.descricao;
      this.premio.pontos = item.pontos;
      this.premio.controlar_qtd = item.controlar_qtd;
      this.premio.qtd = item.qtd;
      this.premio.status = item.status == 1 ? true : false;
      this.premio.fotos = item.premio_fotos;
      this.premio.fotos_remover = [];
      this.premio.campanha_id = item.campanha_id;
      this.premio.cliente = item.cliente;
      this.premio.profissional = item.profissional;
      this.premio.empresa = item.empresa;
      this.premio.all =
        item.empresa == 1 && item.profissional == 1 && item.cliente == 1
          ? true
          : false;
      this.premio.tipo_profissional = [];
      this.premio.premio_areas = item.premio_areas;

      this.validUpdate = true;
      this.$bvModal.show('modal-meus-premios');
    },
    editarCampanha(item) {
      this.campanha.id = item.id;
      this.campanha.nome_campanha = item.nome_campanha;
      this.campanha.descricao = item.descricao;
      this.campanha.inicio_campanha = item.inicio_campanha;
      this.campanha.fim_campanha = item.fim_campanha;
      this.campanha.expira_campanha = item.expira_campanha;
      this.campanha.cliente = item.cliente;
      this.campanha.profissional = item.profissional;
      this.campanha.empresa = item.empresa;
      this.campanha.all =
        item.empresa == 1 && item.profissional == 1 && item.cliente == 1
          ? true
          : false;
      this.campanha.tipo_profissional = [];
      this.campanha.campanha_area = item.campanha_area;
      this.campanha.status = item.status;
      this.campanha.construp_user_id = this.dadosUsuario.id;
      this.$bvModal.show('minhas-campanhas');
    },
    editarRegra(item) {
      this.fields.id = item.id;
      this.fields.nome_regra = item.nome_regra;
      this.fields.descricao = item.descricao;
      this.fields.preco = item.preco;
      this.fields.pontos = item.pontos;
      this.fields.status = item.status;
      this.fields.campanha_id = item.campanha_id;
      this.$bvModal.show('minhas-regras');
    },
    contarCaracteres(texto, qtd) {
      var resultado = texto.substring(0, qtd);
      var pontos = texto.length > qtd ? '...' : '';

      return resultado + pontos;
    },
    removerFoto(i, item) {
      if (!this.premio.fotos_remover) {
        this.premio.fotos_remover = [];
      }

      this.premio.fotos_remover.push(item);
      this.premio.fotos = this.premio.fotos.filter(
        (elemento, index) => index !== i
      );
    },
    selecionaTodos() {
      if (this.campanha.all != true) {
        this.campanha.cliente = true;
        this.campanha.empresa = true;
        this.campanha.profissional = true;
      } else {
        this.campanha.cliente = false;
        this.campanha.empresa = false;
        this.campanha.profissional = false;
      }
    },
    selecionaPremioTodos() {
      if (this.premio.all != true) {
        this.premio.cliente = true;
        this.premio.empresa = true;
        this.premio.profissional = true;
      } else {
        this.premio.cliente = false;
        this.premio.empresa = false;
        this.premio.profissional = false;
      }
    },
    sendFormPremio() {
      var valid = this.validarFormPremio();

      if (valid == true) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/sendFormPremio', this.premio)
          .then((response) => {
            if (response.data.error == false) {
              this.$bvModal.hide('modal-meus-premios');
              this.makeToast('Sucesso', response.data.message, 'success');
              this.get();
            } else {
              this.makeToast('Erro', response.data.message, 'danger');
              this.$store.dispatch('endLoader');
            }
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao buscar seus prêmios!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          });
      }
    },
    alterarStatusPremio(id) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/alterarStatusPremio', id)
        .then((response) => {
          if (response.data.error == false) {
            this.makeToast('Sucesso', 'Status atulizado!', 'success');
            this.get();
          } else {
            this.makeToast(
              'Erro',
              'Houve um erro ao atualizar o status!',
              'danger'
            );
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao atualizar o status!',
            'danger'
          );
          this.$store.dispatch('endLoader');
        });
    },
    uploadImage() {
      const formData = new FormData();
      this.imageSelected = this.$refs.file.files[0];
      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('files/uploadFileApiAppPremio', formData)
        .then((response) => {
          if (response.data.error == true) {
            this.makeToast('Oops!', response.data.message, 'danger');
          } else {
            this.premio.fotos.push({ foto: response.data.foto });
          }
        })
        .catch(() => {
          this.makeToast(
            'Oops!',
            'Não foi possível inserir sua imagem, tente novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getArea(item) {
      const services =
        item && item.pontos_profissional && item.pontos_profissional.services;
      const areas = services
        ? services
            .map((svc) => svc.area_professional && svc.area_professional.area)
            .filter(Boolean)
        : [];

      return areas.length ? areas.join(' | ') : '—';
    },
    validarForm() {
      var valid = true;

      if (this.fields.nome_regra == '') {
        this.makeToast('Opss', 'Informe o nome da regra!', 'danger');
        valid = false;
      }

      if (this.fields.descricao == '') {
        this.makeToast('Opss', 'Informe a descrição da regra!', 'danger');
        valid = false;
      }

      if (this.fields.preco == '' || this.fields.preco == 'R$ 0,00') {
        this.makeToast('Opss', 'Informe o preço da regra!', 'danger');
        valid = false;
      }

      if (this.fields.pontos == '' || this.fields.pontos == null) {
        this.makeToast('Opss', 'Informe o(s) ponto(s) da regra!', 'danger');
        valid = false;
      }

      return valid;
    },
    validarFormPremio() {
      var valid = true;

      if (this.premio.nome_premio == '') {
        this.makeToast('Erro', 'Informe o nome do prêmio!', 'danger');
        valid = false;
      }

      if (this.premio.descricao == '') {
        this.makeToast('Erro', 'Informe a descrição do prêmio!', 'danger');
        valid = false;
      }

      if (this.premio.fotos.length == 0) {
        this.makeToast('Erro', 'Informe a(s) foto(s) do prêmio!', 'danger');
        valid = false;
      }

      if (this.premio.pontos == '' || this.premio.pontos == null) {
        this.makeToast('Erro', 'Informe o(s) ponto(s) do prêmio!', 'danger');
        valid = false;
      }

      if (
        this.premio.controlar_qtd == true &&
        (this.premio.qtd == null || this.premio.qtd == '')
      ) {
        this.makeToast(
          'Erro',
          'Informe a quantidade do prêmio disponível!',
          'danger'
        );
        valid = false;
      }

      return valid;
    },
    validarFormCampanha() {
      var valid = true;

      if (this.campanha.nome_campanha == '') {
        this.makeToast('Opss', 'Informe o nome da campanha!', 'danger');
        valid = false;
      }

      if (this.campanha.descricao == '') {
        this.makeToast('Opss', 'Informe a descrição da campanha!', 'danger');
        valid = false;
      }

      if (
        this.campanha.inicio_campanha == null ||
        this.campanha.inicio_campanha == ''
      ) {
        this.makeToast(
          'Opss',
          'Informe a data do início da campanha!',
          'danger'
        );
        valid = false;
      }

      if (
        this.campanha.fim_campanha == null ||
        this.campanha.fim_campanha == ''
      ) {
        this.makeToast('Opss', 'Informe a data do fim da campanha!', 'danger');
        valid = false;
      }

      if (
        this.campanha.expira_campanha == null ||
        this.campanha.expira_campanha == ''
      ) {
        this.makeToast('Opss', 'Informe a data que expira campanha!', 'danger');
        valid = false;
      }

      if (this.campanha.inicio_campanha > this.campanha.fim_campanha) {
        this.makeToast(
          'Opss',
          'A data do início da campanha não pode ser maior do que data de fim!',
          'danger'
        );
        valid = false;
      }

      if (this.campanha.fim_campanha > this.campanha.expira_campanha) {
        this.makeToast(
          'Opss',
          'A data de fim da campanha não pode ser maior do que data de expiração!',
          'danger'
        );
        valid = false;
      }

      if (
        this.campanha.cliente == false &&
        this.campanha.empresa == false &&
        this.campanha.profissional == false
      ) {
        this.makeToast(
          'Opss',
          'Informe pelo menos um tipo de cliente para a campanha!',
          'danger'
        );
        valid = false;
      }

      return valid;
    },
    formatarValor(valor) {
      var valorReais = (valor / 100).toFixed(2);

      return 'R$ ' + valorReais;
    },
    limparCampos() {
      this.fields.id = null;
      this.fields.nome_regra = '';
      this.fields.descricao = '';
      this.fields.preco = '';
      this.fields.pontos = null;
      this.fields.status = true;
      this.fields.campanha_id = null;
    },
    limparCamposPremio() {
      this.premio.id = null;
      this.premio.nome_premio = '';
      this.premio.descricao = '';
      this.premio.pontos = '';
      this.premio.controlar_qtd = false;
      this.premio.qtd = null;
      this.premio.status = true;
      this.premio.fotos = [];
      this.premio.fotos_remover = [];
      this.premio.campanha_id = null;
      this.campanha.cliente = false;
      this.campanha.profissional = false;
      this.campanha.empresa = false;
      this.campanha.all = false;
      this.campanha.tipo_profissional = [];
      this.campanha.premio_areas = [];

      this.validUpdate = false;
    },
    limparCamposCampanha() {
      this.campanha.id = null;
      this.campanha.nome_campanha = '';
      this.campanha.descricao = '';
      this.campanha.inicio_campanha = null;
      this.campanha.fim_campanha = null;
      this.campanha.expira_campanha = null;
      this.campanha.cliente = false;
      this.campanha.profissional = false;
      this.campanha.empresa = false;
      this.campanha.all = false;
      this.campanha.tipo_profissional = [];
      this.campanha.campanha_area = [];
      this.campanha.status = true;
      this.campanha.construp_user_id = null;
    },
    formatarData(dataHoraOriginal, hora = false) {
      let dataHora = new Date(dataHoraOriginal);

      let opcoesFormato = { day: '2-digit', month: '2-digit', year: 'numeric' };
      if (hora == true) {
        opcoesFormato = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        };
      }

      let dataHoraFormatada = new Intl.DateTimeFormat(
        'pt-BR',
        opcoesFormato
      ).format(dataHora);

      return dataHoraFormatada;
    },
  },
};
</script>

<style scoped>
.statusAtivo {
  background: #3bb53b;
  color: #fff;
  padding: 0 10px;
  border-radius: 4px;
}
.statusInativo {
  background: #e71a1a;
  color: #fff;
  border-radius: 4px;
}
.statusAtivoBtn {
  background: #3bb53b;
  color: #fff;
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 4px;
}
.statusInativoBtn {
  background: #e71a1a;
  color: #fff;
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 4px;
}
.formCheckbox {
  width: 50px;
  height: calc(0.75em + 0.75rem + 5px);
  float: right;
}
.disabledColor {
  background-color: #dc354570;
  border: #dc354570;
}
</style>
